// extracted by mini-css-extract-plugin
export default {"overlay":"GA-z","bodyOpen":"HA-z","content":"IA-z","header":"JA-z","close":"KA-z","closeNoHeading":"LA-z"};